import { useState, useCallback } from 'react';

export default function useGeolocation() {
  const [userLocation, setUserLocation] = useState(null);
  const [locationLoading, setLocationLoading] = useState(true);

  const getCurrentLocation = useCallback(() => {
    const fallbackLocation = { lat: 52.2296756, lng: 21.0122287 };

    setLocationLoading(true);

    if (!navigator.geolocation) {
      console.log('Geolocation not available');
      setLocationLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setUserLocation(coords);
        setLocationLoading(false);
      },
      (error) => {
        console.log('Error getting location:', error.message);
        setLocationLoading(false);

        switch (error.code) {
          case error.PERMISSION_DENIED:
            console.log('User denied the request for Geolocation');
            break;
          case error.POSITION_UNAVAILABLE:
            console.log('Location information is unavailable');
            break;
          case error.TIMEOUT:
            console.log('The request to get user location timed out');
            break;
          default:
            console.log('An unknown error occurred');
            break;
        }

        setLocationLoading(false);
        setUserLocation(fallbackLocation);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000,
      }
    );
  }, []);

  return { userLocation, setUserLocation, locationLoading, getCurrentLocation };
}
